import type { EndowNotification as EndowNotificationType } from '@/@types/notification'
import GiftIcon from '@/assets/gift.svg?react'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import { AvatarGroup } from '@mantine/core'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import Avatar from '../Avatar'
import ScreenNames from '../ScreenNames'
import styles from './EndowNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface EndowNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: EndowNotificationType
}

export default function EndowNotification({ data, className, ...props }: EndowNotificationProps) {
	const {
		actionItem: { users, usersCount },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<header className={styles.header}>
					<GiftIcon className={styles.icon} />
					<div className={styles.headerText}>
						<ScreenNames data={users} className={styles.screenNames} />
						<span className={styles.secondaryText}>
							{usersCount > 3 && <span>等{usersCount}人</span>}
							给你的动态赠送了礼物
						</span>
					</div>
				</header>

				<main>
					<AvatarGroup spacing="md">
						{users.map((user) => (
							<Avatar key={user.id} data={user} />
						))}
					</AvatarGroup>
				</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
